var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvertismentSettings01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke-linejoin: round;\n      }\n\n      .cls-1 {\n        stroke: #000;\n      }\n\n      .cls-2, .cls-3 {\n        stroke: #030708;\n        stroke-linecap: round;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Advertisment Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.18,23.73H20.42a0,0,0,0,1,0,0V37.46a0,0,0,0,1,0,0H10.18A6.66,6.66,0,0,1,3.52,30.8v-.41A6.66,6.66,0,0,1,10.18,23.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.42,24.06,27,18.87a1.15,1.15,0,0,1,1.86.9V41.33a1.23,1.23,0,0,1-2,1l-6.48-4.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.86,25.84a5.28,5.28,0,0,1,0,10.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.67,37.46,13.61,51.1a2.77,2.77,0,0,0,2.71,2.19h0a2.77,2.77,0,0,0,2.76-3L17.91,37.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.16,43.92l1.47-.64a1,1,0,0,1,1,.12A16.64,16.64,0,0,0,26.44,45a1,1,0,0,1,.61.83l.56,4.91a1,1,0,0,0,.9.92l3.93.52a1,1,0,0,0,1.1-.65L35.37,47a1,1,0,0,1,.81-.64,17.28,17.28,0,0,0,3.1-.83,1,1,0,0,1,1,.15l3.86,3.08a1.05,1.05,0,0,0,1.29,0l3.15-2.41a1.05,1.05,0,0,0,.32-1.25l-2-4.53a1.06,1.06,0,0,1,.12-1,16.55,16.55,0,0,0,1.61-2.77,1.06,1.06,0,0,1,.83-.62l4.91-.55a1.06,1.06,0,0,0,.92-.9l.52-3.93a1,1,0,0,0-.65-1.11l-4.59-1.82A1.06,1.06,0,0,1,50,27a16.85,16.85,0,0,0-.83-3.1,1,1,0,0,1,.16-1L52.39,19a1,1,0,0,0,0-1.28L50,14.58a1,1,0,0,0-1.24-.33l-4.54,2a1,1,0,0,1-1-.12,16.55,16.55,0,0,0-2.77-1.61,1,1,0,0,1-.62-.83l-.55-4.91a1.05,1.05,0,0,0-.9-.91L34.42,7.3A1.06,1.06,0,0,0,33.31,8l-1.82,4.59a1,1,0,0,1-.81.64,16.85,16.85,0,0,0-3.1.83,1.06,1.06,0,0,1-1-.15l-3.86-3.08a1,1,0,0,0-1.28,0l-3.15,2.41a1,1,0,0,0-.33,1.24L19.05,17l.84,2a1,1,0,0,1-.12,1c.25-.34.16-.27-.13.17-.17.24-.4.61-.68,1.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.23,
    y1: 27.86,
    x2: 40.5,
    y2: 25.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 37.26,
    y1: 30.86,
    x2: 41.46,
    y2: 31.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.28,
    y1: 34.21,
    x2: 40.45,
    y2: 36.41
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertismentSettings01);
export default __webpack_public_path__ + "static/media/Advertisment_Settings_01.4770e4ad76240d9e34bf728491a3ff18.svg";
export { ForwardRef as ReactComponent };